import { render, staticRenderFns } from "./ImportsScreen.vue?vue&type=template&id=d2faa7f6&scoped=true"
import script from "./ImportsScreen.vue?vue&type=script&lang=js"
export * from "./ImportsScreen.vue?vue&type=script&lang=js"
import style0 from "./ImportsScreen.vue?vue&type=style&index=0&id=d2faa7f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2faa7f6",
  null
  
)

export default component.exports